import {DEFAULT_MSG} from 'constants'
import {toast} from 'react-toastify'
import {store} from 'store'

export const scrollToTop = () => window.scrollTo(0, 0)

export const parseError = (error) =>
  error?.message || error?.meta?.message || DEFAULT_MSG.StandardErrorMsg

export const alertError = (error) => {
  const storeState = store.getState()
  if (storeState.configs.isOnline) toast.error(parseError(error))
}

export const removeCommaFromStr = (val) => (val ? val.toString().replace(/,/g, '').trim() : '')

export const tryParseInt = (val, defaultValue = 0) => {
  val = parseInt(removeCommaFromStr(val))
  return isNaN(val) ? defaultValue : val
}

export const tryParseFloat = (val, defaultValue = 0) => {
  val = parseFloat(removeCommaFromStr(val))
  return isNaN(val) ? defaultValue : val
}

export const thousandFormat = (num, decimalPoint = 2) =>
  tryParseFloat(num)
    .toFixed(decimalPoint)
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
